module.exports = __webpack_public_path__ + "media/images/tutorial_body_pc2-03-6b540b18b4c705758d825bc786bbb849.png";